import { OnboardingRootState } from "../reducers/rootReducer";
import { getOnboardingState } from "./rootSelectors";

export const getCountryValidationsList = (state: OnboardingRootState) =>
  getOnboardingState(state).partnerCenter?.countryValidations;

export const getCountryValidationsByCode = (state: OnboardingRootState, code: string) =>
  (getOnboardingState(state).partnerCenter?.countryValidations &&
    getOnboardingState(state).partnerCenter?.countryValidations?.[code]) ??
  null;

export const getPartnerCenterSellers = (state: OnboardingRootState) =>
  getOnboardingState(state).partnerCenter?.sellers ?? [];

export const getMiddlewarePartners = (state: OnboardingRootState) =>
  getOnboardingState(state).partnerCenter?.middlewarePartners ?? [];

export const getAddressValidationState = (state: OnboardingRootState) =>
  getOnboardingState(state).partnerCenter?.addressValidation;

export const getAddressValidationStatus = (state: OnboardingRootState) =>
  getOnboardingState(state).partnerCenter?.addressValidation?.status ?? "idle";

export const getSuggestedAddresses = (state: OnboardingRootState) =>
  getOnboardingState(state).partnerCenter?.addressValidation?.suggestedAddresses ?? [];

export const getAddressValidationOriginalAddress = (state: OnboardingRootState) =>
  getOnboardingState(state).partnerCenter?.addressValidation?.originalAddress;
